module.exports = __webpack_public_path__ + "img/16d004-17.327aa82c.jpg";